import React from "react";
import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function NotFound() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f5f5f5"
      p={3}
    >
      <Box textAlign="center" maxWidth={400}>
        <ErrorOutlineIcon color="error" sx={{ fontSize: 60, mb: 2 }} />
        <Typography variant="h4" color="error" fontWeight="bold" gutterBottom>
          Document Not Found
        </Typography>
        <Typography variant="body1" color="textSecondary" mb={4}>
          The document you are trying to access does not exist, has been
          removed, or the link is invalid.
        </Typography>
        <Typography variant="body2" color="textSecondary" mb={4}>
          Please contact the sender for assistance or verify the link you have.
        </Typography>
      </Box>
    </Box>
  );
}
